import PageHeader from 'components/PageHeader';
import ListCreateButton from 'components/buttons/ListCreateButton';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import TasksTable from './TasksTable';

const TasksPage = (): JSX.Element => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'tasks.tasks'}
                    showBreadcrumb
                    buttons={
                        <ListCreateButton
                            permissions={['CREATE.TASKS']}
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => navigateWithReturn(`/task/new`)}
                            labelId="tasks.add-task"
                            newLabelId="new-entity.task"
                        />
                    }
                />
                <TasksTable />
            </div>
        </PaddedLayout>
    );
};

export default TasksPage;
